export class DeleteCartItemRequestPayload {
  /**
   * 
   * @param {Object} options
   * @param {string} options.sku
   */
  constructor({ sku }) {
    this.sku = sku;
  }

  /**
   * Converts a plain object suitable for JSON.stringify()
   */
  toJSON() {
    return {
      sku: this.sku,
    }
  }
}